import React, { useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import { ClipboardList } from 'lucide-react';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import BulkAddAccessorialsModal from 'components/modules/shipments/accounting/BulkAddAccessorialsModal';
const fscAccessorialTypes = {
    FSC: 'fuel_surcharge',
};
export default function AddAccessorialNextStep({ item, shipment }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const renderIcon = () => {
        return !item.complete ? (React.createElement(ClipboardList, { className: "w-5 h-5" })) : (React.createElement("div", { className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", null, t(sluggify(item.field))),
            React.createElement(CircleButton, { size: "small", disabled: item.complete, onClick: () => setShowModal(true) }, renderIcon())),
        showModal && (React.createElement(BulkAddAccessorialsModal, { show: showModal, orderId: shipment.order._id || null, shipmentIds: [shipment.id], onHide: () => setShowModal(false), defaultAccessorialType: fscAccessorialTypes.FSC }))));
}
